import React, { useState } from 'react';
import { Header } from './components/Header';
import { CatalogPage } from './pages/CatalogPage';
import { VehicleDetail } from './pages/VehicleDetail';
import { MessageCircle } from 'lucide-react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ScrollToTop } from './components/ScrollToTop';
export function App() {
  const [searchQuery, setSearchQuery] = useState('');
  return <BrowserRouter data-id="element-0" data-mp="2rlypgcwhuiig">
      <ScrollToTop data-id="element-1" data-mp="2rlf5kqna9k1s" />
      <div className="min-h-screen bg-[#22251F] font-sans text-[#F2F0E9]" data-id="element-2" data-mp="2risy0r0e74jk">
        <Header data-id="element-3" data-mp="2mndqshww46w4" />

        <Routes data-id="element-4" data-mp="2mjpx9irg3khe">
          <Route path="/" element={<CatalogPage searchQuery={searchQuery} setSearchQuery={setSearchQuery} data-id="element-6" data-mp="31c9y2cr4hfvo" />} data-id="element-5" data-mp="31aqfgfhzusqq" />
          <Route path="/autos/:id" element={<VehicleDetail data-id="element-8" data-mp="28suumo7jhzm9" />} data-id="element-7" data-mp="28tw44o8wqe1v" />
        </Routes>

        <a href="https://wa.me/541139465079" target="_blank" rel="noopener noreferrer" aria-label="Consultar por WhatsApp" className="wa-blink fixed bottom-6 right-6 w-14 h-14 bg-[#25D366] hover:bg-[#128C7E] text-white rounded-full shadow-lg flex items-center justify-center transition-colors z-40 hover:scale-110" data-id="element-9" data-mp="23vcmh01cjofb">
          <MessageCircle className="w-7 h-7" data-id="element-10" data-mp="3reccfffk0fdk" />
        </a>
      </div>
    </BrowserRouter>;
}